import { render, staticRenderFns } from "./PublicCopyright.vue?vue&type=template&id=5157c6c3&lang=pug&"
import script from "./PublicCopyright.vue?vue&type=script&lang=js&"
export * from "./PublicCopyright.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports